import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public errors = [];
  public loginForm: FormGroup;

  constructor(private authService: AuthenticationService, private router: Router, private fileService: FileService) {
    this.loginForm = new FormGroup({
      'email': new FormControl('', [Validators.email,Validators.required]),
      'password': new FormControl(null, Validators.required)
    });
  }

  ngOnInit() {
  }

  login(){
    this.errors=[];
    this.authService.login(this.loginForm.get('email').value,this.loginForm.get('password').value).subscribe(res=>{
      this.authService.storeLogin(res);
      this.router.navigate(['/']);
    },err=>{
      this.errors.push(err.error.error);
    })
  }

}
